export const styles = {
  page: (isMobile) => ({
    flex: 1,
    minWidth: 0,
    minHeight: "100vh",
    overflowY: "auto",
    boxSizing: "border-box",
    padding: isMobile ? 16 : 32,
    background: "linear-gradient(180deg, #f8fbff 0%, #eef4ff 100%)",
  }),
  header: (isMobile) => ({
    display: "flex",
    alignItems: "center",
    gap: isMobile ? 10 : 14,
    marginBottom: isMobile ? 18 : 26,
  }),
  icon: (isMobile) => ({
    width: isMobile ? 44 : 50,
    height: isMobile ? 44 : 50,
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    borderRadius: 14,
    color: "#fff",
    background: "linear-gradient(135deg, #1f3a70, #3d5bb8)",
  }),
  title: { margin: 0, color: "#15233c", fontSize: 23 },
  subtitle: { margin: "5px 0 0", color: "#6a7c96", fontSize: 14 },
  card: (isMobile) => ({ position: "relative", minHeight: isMobile ? 280 : 320, background: "#fff", border: "1px solid #e3eaf5", borderRadius: 18, padding: 20, boxShadow: "0 16px 40px rgba(34, 60, 80, 0.07)", boxSizing: "border-box" }),
  loadingOverlay: (isMobile) => ({
    position: "absolute",
    inset: 0,
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
    borderRadius: isMobile ? 14 : 18,
  }),
  spinner: (isMobile) => ({
    width: isMobile ? 32 : 40,
    height: isMobile ? 32 : 40,
    border: isMobile ? "3px solid #cbd5e1" : "4px solid #cbd5e1",
    borderTop: isMobile ? "3px solid rgb(31, 58, 112)" : "4px solid rgb(31, 58, 112)",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  }),
  emptyState: (isMobile) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: isMobile ? 24 : 48,
    gap: 16,
    color: "#cbd5e1",
  }),
  emptyMessage: { margin: 0, color: "#5d6f8a", fontSize: 14 },
  toolbar: (isMobile) => ({ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 10, marginBottom: 18 }),
  input: { flex: 1, minWidth: 0, padding: "12px 14px", border: "1px solid #dbe4f0", borderRadius: 10, outline: "none", fontSize: 14 },
  select: { padding: "12px 14px", border: "1px solid #dbe4f0", borderRadius: 10, background: "#fff", color: "#223047", fontSize: 14 },
  list: { display: "grid", gap: 10 },
  item: { display: "grid", gridTemplateColumns: "minmax(0, 1fr) auto", gap: 12, padding: 16, border: "1px solid #e7edf6", borderRadius: 12, background: "#fbfdff", cursor: "pointer" },
  itemTitle: { display: "flex", alignItems: "center", gap: 7, margin: 0, color: "#15233c", fontSize: 15 },
  description: { margin: "6px 0 0", color: "#6a7c96", fontSize: 13, lineHeight: 1.45 },
  meta: { display: "flex", alignItems: "flex-start", flexDirection: "column", gap: 6, textAlign: "right" },
  badge: (status) => {
    const colors = {
      aberto: { color: "#805700", background: "#fff6df", border: "#f1d590" },
      "em andamento": { color: "#2456a6", background: "#e9f2ff", border: "#c8dcfb" },
      pendente: { color: "#9a4e10", background: "#fff1e5", border: "#f3d0b3" },
      concluido: { color: "#17663d", background: "#e7f6ee", border: "#c3e6d1" },
      rejeitado: { color: "#a3312a", background: "#fff0ef", border: "#f1cbc8" },
      fechado: { color: "#17663d", background: "#e7f6ee", border: "#c3e6d1" },
      cancelado: { color: "#a3312a", background: "#fff0ef", border: "#f1cbc8" },
    };
    const statusColors = colors[status] || { color: "#435466", background: "#eef2f5", border: "#d9e1e7" };

    return {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 4,
      padding: "4px 9px",
      border: `1px solid ${statusColors.border}`,
      borderRadius: 999,
      fontSize: 11,
      fontWeight: 700,
      color: statusColors.color,
      background: statusColors.background,
    };
  },
  date: { color: "#8a99ad", fontSize: 11 },
  state: { padding: 36, color: "#6a7c96", textAlign: "center", fontSize: 14 },
};